/**
 * Central API configuration.
 * 
 * Handles three environments:
 * 1. localhost (dev): Uses REACT_APP_BACKEND_URL from .env
 * 2. preview (emergentagent.com): Uses REACT_APP_BACKEND_URL from .env
 * 3. production (microsafe.as or other custom domain): Uses window.location.origin
 * 
 * This ensures API calls are always same-origin in production,
 * avoiding CORS issues entirely.
 */
const ENV_URL = process.env.REACT_APP_BACKEND_URL || '';

function resolveBackendUrl() {
  if (typeof window === 'undefined') return ENV_URL;

  const currentOrigin = window.location.origin;

  // Local development: use env variable
  if (currentOrigin.includes('localhost')) {
    return ENV_URL;
  }

  // Check if env URL matches current origin (preview environment)
  if (ENV_URL) {
    try {
      if (new URL(ENV_URL).origin === currentOrigin) {
        return ENV_URL;
      }
    } catch (e) {}
  }

  // Production / custom domain: use current origin
  return currentOrigin;
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;
